const storage = {
  getAccessToken: () => {
    const value = localStorage.getItem("access_token");
    return value ? value : null;
  },

  setItem: (key, value) => {
    localStorage.setItem(key, value);
  },

  getItem: (key) => {
    const value = localStorage.getItem(key);
    return value ? value : null;
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },

  clearStorage: () => {
    localStorage.clear();
  },
};

export default storage;
